import { createContext } from 'react'

import { WorkspaceFormContextType } from './types'

export const WorkspaceFormContext = createContext<WorkspaceFormContextType>(
  {} as WorkspaceFormContextType,
)
